import React, { Fragment } from 'react';

import { token } from '@atlaskit/tokens';

import type { ColorTable } from './types';

export const BRAND_AND_NEUTRAL_CHART_TOKENS: ColorTable[] = [
	{
		name: 'color.chart.brand',
		description: (
			<Fragment>
				Our primary color for data visualization. Use when only one color is required.
			</Fragment>
		),
		token: token('color.chart.brand'),
	},
	{
		name: 'color.chart.neutral',
		description: (
			<Fragment>
				A secondary color for data visualization. Use for the less important data when you want
				other data to stand out.
			</Fragment>
		),
		token: token('color.chart.neutral'),
	},
];
